<template>
    <div>
        <van-radio-group v-model="radio1" @change="change">
            <van-radio name="wsf">万商服</van-radio>
            <van-radio name="wic">智慧商业</van-radio>
        </van-radio-group>
        <hr>
        <van-radio-group v-model="radio2" @change="change">
            <van-radio name="sit">测试环境</van-radio>
            <van-radio name="prod">生产环境</van-radio>
        </van-radio-group>
        <hr>
        <van-radio-group v-model="radio3" @change="change">
            <van-radio :name="`${index}`" v-for="(item, index) in radioList3" :key="index">{{ item.lable }}</van-radio>
        </van-radio-group>
        <hr>
        url:
        <div style="line-height: 1;word-break: break-all;">{{ url }}</div>
        <hr>
        <van-button type="primary" @click="copy">复制url</van-button>
    </div>
</template>

<script>

export default {
  data() {
    return {
      radio1: 'wsf',
      radio2: 'sit',
      radio3: '0',
      radioList3: [
        {
          lable: '电签',
          url: '/dq/auth?weChatOfficialAccountType='
        },
        {
          lable: '经营期保险',
          url: '/insure_auth?pageType=insure_operating&weChatOfficialAccountType='
        },
        {
          lable: '施工期保险',
          url: '/insure_auth?pageType=insure_building&weChatOfficialAccountType='
        },
        {
          lable: '服务商保险',
          url: '/insure_auth?pageType=insure_service&weChatOfficialAccountType='
        },
        {
          lable: '商户员工意外险',
          url: '/insure_auth?pageType=insure_worker_owner&weChatOfficialAccountType='
        },
        {
          lable: '推荐保险',
          url: '/insure_auth?pageType=insure_suggest&weChatOfficialAccountType='
        },
        {
          lable: '本店保险',
          url: '/insure_auth?pageType=myInsure&weChatOfficialAccountType='
        },
      ],
      url: ''
    }
  },
  methods: {
    change() {
      console.log(this.radio1);
      console.log(this.radio2);
      console.log(this.radio3);
      let x = {
        'wsfsit': '​http://wicmp.wanda-dev.cn/h5-app-sh/#',
        'wsfprod': '​http://mp.wanda.cn/h5-app-sh/#',
        'wicsit': '​http://mp.wanda.cn/h5-app-sh/#',
        'wicprod': '​http://mp.wanda.cn/h5-app-sh/#',
      }

      let y = this.radioList3[this.radio3].url
      if (this.radio1 + this.radio2 == 'wicsit') {
        y = y.replace('dq', 'dq_dev').replace('insure_auth', 'insure_auth_dev')
      }
      let z = this.radio1 == 'wsf' ? '1' : '2'
      let url = `${x[this.radio1 + this.radio2]}${y}${z}`
      this.url = url
    },
    copy() {
            //创建临时的输入框元素
      function createElement(text) {
        var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
        var element = document.createElement('textarea');
                // 防止在ios中产生缩放效果
        element.style.fontSize = '12pt';
                // 重置盒模型
        element.style.border = '0';
        element.style.padding = '0';
        element.style.margin = '0';
                // 将元素移到屏幕外
        element.style.position = 'absolute';
        element.style[isRTL ? 'right' : 'left'] = '-9999px';
                // 移动元素到页面底部
        let yPosition = window.pageYOffset || document.documentElement.scrollTop;
        element.style.top = `${yPosition}px`;
                //设置元素只读
        element.setAttribute('readonly', '');
        element.value = text;
        document.body.appendChild(element);
        return element;
      }
      var element = createElement(this.url);
      element.select();
      element.setSelectionRange(0, element.value.length);
      document.execCommand('copy');
      element.remove();
      alert('已复制到剪切板');
    }
  },
  mounted() {
    let x = {
      'wsfsit': '​http://wicmp.wanda-dev.cn/h5-app-sh/#',
      'wsfprod': '​http://mp.wanda.cn/h5-app-sh/#',
      'wicsit': '​http://mp.wanda.cn/h5-app-sh/#',
      'wicprod': '​http://mp.wanda.cn/h5-app-sh/#',
    }

    let y = this.radioList3[this.radio3].url
    if (this.radio1 + this.radio2 == 'wicsit') {
      y = y.replace('dq', 'dq_dev').replace('insure_auth', 'insure_auth_dev')
    }
    let z = this.radio1 == 'wsf' ? '1' : '2'
    let url = `${x[this.radio1 + this.radio2]}${y}${z}`
    console.log(url);
    this.url = url
  }
}
</script>
<style scoped> div {
     font-size: 16px;
 }

 .van-radio {
     margin-top: 2px;
 }
</style>

